export default {
    getLazyLoadPluginInfo(state){
        return state.lazyLoadPluginInfo;
    },
    getRegisteredOverFlowMenu(state) {
        return state.overFlowMenu;
    },
    getRegisteredQuickAccessPannel(state) {
        return state.quickAccessPanel;
    },
    getSortedQuickAccessPanel(state){
        return state.quickAccesPanelSortedArr;
    },
    getRegisteredSettingsSidemenu(state) {
        return state.settingsSideMenu;
    },
    getRegisteredFloatingMenu(state) {
        return state.floatingMenu;
    },
    getRegisteredBinsContextMenu(state) {
        return state.binsContextMenu;
    },
    getRegisteredBinsMoreContextMenu(state) {
        return state.binsMoreContextMenu;
    },
    getRegisteredBinsNewContextMenu(state) {
        return state.binsNewContextMenu;
    },
    getRegisteredBinsImportContextMenu(state) {
        return state.binsImportContextMenu;
    },
    getRegisteredShareContextMenu(state){
        return state.binsShareContextMenu;
    },
    getRegisteredCatalogIconContextMenu(state){
        return state.catalogIconContextMenu;
    },
    getRegisteredExportContextMenu(state){
        return state.exportContextMenu;
    },
    getRegisteredAIToolsContextMenu(state){
        return state.binsAIToolsContextMenu;
    },
    getRegisteresOpenWithContextMenu(state){
        return state.binsOpenWithContextMenu;
    },
    getRegisteredPreferencesSidemenu(state) {
        return state.preferencesSidemenu;
    },
    getRegisteredImportExportMenus(state) {
        return state.importExportMenu;
    },
    getRegisteredSystemMenus(state) {
        return state.systemSettingsMenu;
    },
    getRegisteredPropertiesTopNav(state) {
        return state.propertiesTopNav;
    },
    getRegisteredDialogForMediaBrowse(state) {
        return state.dialogForMediaBrowse;
    },
    getRegisteredShareTopNavMenus(state) {
        return state.shareTopNavMenu;
    },
    getRegisteredReportsSidemenu(state){
        return state.reportsSideMenu;
    },  
    getRegisteredPluginMapper(state){
        return state.pluginMapper;
    },
    getRegisteredDashboardWidgets(state){
        return state.dashboardWidgets; 
    },
    getRegisteredGlobalNewButtons(state){
        return state.externalGlobalNewButtonPlugins;
    },
    getRegisteredCreateReviewButtons(state){
        return state.createReviewButtons;
    },
    getPropertiesMetadataPlugins(state){
        return state.metadataPluginExpandCollapseList;
    },
    getMetadataDockListPlugins(state){
        return state.metadataDockPluginsList;
    },
    getPluginLicensePlugins(state){
        return state.licenseInfoDetails;
    },
    getReviewTagsArr(state){
        return state.reviewTagsArr;
    },
    getPropertiesTabPlugins(state){
        return state.propertiesTabsPlugins;
    },
    getExposedComponents(state){
        return state.damComponentOnDemand;
    },
    getpamBrowsePluginsList(state){
        return state.pamBrowsePluginsList;
    },
    getSubclipPlugins(state){
        return state.subclipPluginsList;
    },
    getDashboardWidgetsPlugins(state){
        return state.dashboardWidgetPlugin;
    },
    getMyAppPlugins(state){
        return state.myApps;
    },
    getLinksBrowseListPlugins(state){
        return state.linksBrowsePluginsList;
    },
    getCustomReportsSelectionField(state){
        return state.customReportsSelectionField;
    },
    getPluginRouterRoutesForLoading(state){
        return state.registeredPluginRoutesForLoadingMapper;
    },
    getDontPlayOverlayScreenOverMiniplayerAssetDoc(state){
         return state.dontPlayMiniplayerInTheBackround_openedScreens;
    }
};